let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("kM9x8")).then(() => parcelRequire('hox2O'));